

export function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

export const openPreview = (url) => {
    if (!url) return;
  
    const ext = url.split('.').pop().split('?')[0].toLowerCase();
  
    // Excel & Word → Microsoft Office Viewer
    if (['xlsx', 'xls', 'docx', 'doc', 'pptx'].includes(ext)) {
      const viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
      window.open(viewerUrl, '_blank');
      return;
    }
  
    // PDF / Images → direct preview
    if (['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
      window.open(url, '_blank');
      return;
    }
  
    // Fallback → download
    window.location.href = url;
  };   
